import { render, staticRenderFns } from "./DarkMode.vue?vue&type=template&id=b6853bc2&"
import script from "./DarkMode.vue?vue&type=script&lang=js&"
export * from "./DarkMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports